<template>
    <div :class="menuClass">
        <div class="container-fluid">
            <div class="row mt-3 menu-effects">
                <div class="col-12 d-sm-none">
                    <div class="float-left text-white">
                        <h5 @click.prevent="closeMenuFxn" class="clickable"><i class="fas fa-bars text-white"></i> MENU</h5>
                    </div>
                    <div class="float-right">
                        <h4 @click.prevent="closeMenuFxn" class="clickable"><i class="fas fa-times text-white"></i></h4>
                    </div>
                    <div class="clearfix"></div>
                </div>

                <!-- aNewItem shoppers link -->
                <div class="col-md-3 col-sm-4 col-12">
                    <div class="text-white">
                        <p class="font-weight-bold d-none d-sm-block">QUICK LINKS</p><hr>
                        <p @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'home' }" exact><i class="fas fa-store"></i> Home</router-link>
                        </p>
                        <p v-if="loggedInUser" @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'customer-account' }" exact><i class="fas fa-user"></i> My Account</router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'shopping-cart' }" exact><i class="fas fa-shopping-cart"></i> Shopping Cart</router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'saved-later' }" exact><i class="fas fa-save"></i> Saved Items</router-link>
                        </p>
                        <p v-if="loggedInUser" @click.prevent="userSignout">
                            <router-link :to="{ name: 'signin' }" exact><i class="fas fa-power-off"></i> Sign Out</router-link>
                        </p>
                        <p v-else @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'signin' }" exact><i class="fas fa-user"></i> Sign In</router-link>
                        </p>
                    </div>
                </div>
                
                <!-- for aNewItem inventory staff members alone - starts -->
                <div v-if="portalAccess" class="col-md-3 col-sm-4 col-12">
                    <div class="text-white mt-5 mt-sm-0">
                        <p class="font-weight-bold">STAFF ZONE</p><hr>
                        <p @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'profile' }" exact><i class="fas fa-lock"></i> Active Profile</router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'selling' }" exact><i class="fas fa-lock"></i> Selling Items</router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'buying' }" exact><i class="fas fa-lock"></i> Buying Items</router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'transactions' }" exact><i class="fas fa-lock"></i> Transactions</router-link>
                        </p>
                        <p @click.prevent="gotoShop">
                            <a class="clickable"><i class="fas fa-lock"></i> Items Portal</a>
                        </p>
                    </div>
                </div>
                <!-- for aNewItem inventory staff members alone - stops -->
                
                <!-- most popular categories -->
                <div v-if="theMostCategoryItems" class="col-md-3 col-sm-4 col-12" v-bind:class="{ 'd-sm-none d-md-block' : portalAccess }">
                    <div class="text-white mt-5 mt-sm-0">
                        <p class="font-weight-bold">MOST CATEGORIES</p><hr>
                        <p @click.prevent="closeMenuFxn" v-for="(categoryObj, index) in theMostCategoryItems" :key="index" >
                            <router-link  :to="{ name: 'category-items', params: { category: categoryObj.category } }" exact>
                                {{categoryObj.category | capitalize}}
                            </router-link>
                        </p>
                    </div>
                </div>
                
                <!-- some randomized categories -->
                <div v-if="!portalAccess && theCategories" class="col-md-3 col-sm-4 col-12 d-sm-none d-md-block">
                    <div class="text-white mt-5 mt-sm-0">
                        <p class="font-weight-bold">MORE CATEGORIES</p><hr>
                        <p @click.prevent="closeMenuFxn" v-for="(categoryObj, index) in theCategories" :key="index" >
                            <router-link  :to="{ name: 'category-items', params: { category: categoryObj.category } }" exact>
                                {{categoryObj.category | capitalize}}
                            </router-link>
                        </p>
                    </div>
                </div>

                <!-- aNewItem business links -->
                <div class="col-md-3 col-sm-4 col-12">
                    <div class="text-white mt-5 mt-sm-0">
                        <p class="font-weight-bold">COMPANY LINKS</p><hr>
                        <p>Support</p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link  :to="{ name: 'about' }" exact>
                                About
                            </router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link  :to="{ name: 'careers' }" exact>
                                Careers
                            </router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link  :to="{ name: 'privacy-policy' }" exact>
                                Privacy Policy
                            </router-link>
                        </p>
                        <p @click.prevent="closeMenuFxn">
                            <router-link  :to="{ name: 'tandc' }" exact>
                                Terms &amp; Conditions
                            </router-link>
                        </p>
                    </div>
                </div>
                <div class="col-12 d-sm-none">
                    <div class="text-white my-5">
                        <small @click.prevent="closeMenuFxn">
                            <router-link :to="{ name: 'home' }">
                                &copy; {{Date.now() | moment('YYYY')}} aNewItem.com
                            </router-link>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "Menu",
    props: {
        menuClass: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        ...mapActions(['signOut']),
        userSignout() {
            this.signOut().then(() => {}).catch((e) => {})
        },
        closeMenuFxn() {
            this.$emit('emitCloseMenuFxn', true)
        },
        gotoShop() {
            if(!this.portalAccess) return
            
            // close the overlayed menu display
            this.closeMenuFxn()

            // redirect to the correct page
            if(this.user.shopOwner){
                if(this.authShop){
                    return this.$router.push({
                        name: 'dashboard'
                    }).catch((e) => {})
                }
                this.$router.push({
                    name: 'lock-screen'
                }).catch((e) => {})
            } else {
                this.$router.push({
                    name: 'create-shop'
                }).catch((e) => {})
            }
        }
    },
    computed: {
        ...mapGetters(['setCategories', 'mostCategoryItems', 'authenticated', 'user', 'authShop']),
        loggedInUser() {
            if(this.authenticated && this.user){
                return this.user
            }
            return false
        },
        portalAccess() {
            if(this.loggedInUser){
                // fetch logged in users roles and see if permitted role is included
                if(this.loggedInUser.roles.includes(process.env.VUE_APP_STF_ROLE) === true) return true
            }
            return false
        },
        theMostCategoryItems() {
            if(this.mostCategoryItems) {
                // only return 5 categories with the already sorted with highest items desc
                return this.mostCategoryItems.slice(0, 5)
            }
            return false
        },
        theCategories() {
            if(this.setCategories) {
                // store the categories in an array
                let categoriesArr = this.setCategories
                let shuffleCategoriesArr = []

                // don't show any category already shown from theMostCategoryItems
                if(this.theMostCategoryItems) {
                    let mostCategoryItems = this.theMostCategoryItems
                    for (let x=0; x < categoriesArr.length; x++) {
                        let categoryIndex = mostCategoryItems.findIndex(catObj => catObj.category === categoriesArr[x].category)
                        // only push into the shuffle array if the category-obj isn't in the most-category-arr
                        if(categoryIndex === -1){ 
                            shuffleCategoriesArr.push(categoriesArr[x])
                        }
                    }
                } 
                // in case no most category was set
                else {
                    shuffleCategoriesArr = categoriesArr
                }

                // shuffle the categories here and return only 5 categories
                for(let i=0; i < shuffleCategoriesArr.length; i++){
                    let j = Math.floor(Math.random() * i)
                    let temp = shuffleCategoriesArr[i]
                    shuffleCategoriesArr[i] = shuffleCategoriesArr[j]
                    shuffleCategoriesArr[j] = temp
                }
                return shuffleCategoriesArr.slice(0, 5)
            }
            return false
        }
    },
}
</script>
